export const emailEW = "support@workl.com"

export const emailEB = "support@workl.com"
